<template>
    <div>
        <button type="button" class="d-none" id="btn-modal-passing-grade-limit" data-bs-toggle="modal" data-bs-target="#passing-grade-limit-modal-form">Klik</button>
        <div class="modal" id="passing-grade-limit-modal-form" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="row align-items-center mb-4">
                            <div class="col">
                                <div class="h1 m-0 display-tektur">
                                    Batas Posibilitas Minimum
                                </div>
                            </div>
                            <div class="col-auto">
                                <button type="button" class="btn btn-white-naked btn-icon" data-bs-dismiss="modal" aria-label="Close">
                                    <i class="fa-solid fa-xmark"></i>
                                </button>
                            </div>
                        </div>
                        <form v-on:submit.prevent="onSubmit">
                            <div class="d-block px-2">
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group form-style-1">
                                            <label class="form-label">Min PM UTBK<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <input type="number" class="form-control" placeholder="Masukan min PM UTBK" v-model="form.min_pg_utbk" required oninvalid="this.setCustomValidity('Masukan nilai minimal UTBK')" oninput="this.setCustomValidity('')">
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group form-style-1">
                                            <label class="form-label">Max PM UTBK<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <input type="number" class="form-control" placeholder="Masukan max PM UTBK" v-model="form.max_pg_utbk" required oninvalid="this.setCustomValidity('Masukan nilai maximal UTBK')" oninput="this.setCustomValidity('')">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group form-style-1">
                                            <label class="form-label">Min PM Rapor<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <input type="number" class="form-control" placeholder="Masukan min PM Rapor" v-model="form.min_pg_rapor" required oninvalid="this.setCustomValidity('Masukan nilai minimal rapor')" oninput="this.setCustomValidity('')">
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group form-style-1">
                                            <label class="form-label">Max PM Rapor<i class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                            <input type="number" class="form-control" placeholder="Masukan max PM Rapor" v-model="form.max_pg_rapor" required oninvalid="this.setCustomValidity('Masukan nilai maximal rapor')" oninput="this.setCustomValidity('')">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex align-items-center justify-content-between border-top pt-4">
                                <div class="d-block small">
                                    <i class="fa-solid fa-circle-exclamation me-2 text-pink"></i>Wajib diisi
                                </div>
                                <div class="d-flex align-items-center">
                                    <button type="button" class="btn btn-white-naked btn-s-1 me-3" data-bs-dismiss="modal" aria-label="Close" id="btn-close-modal-passing-grade-limit">
                                        <div class="btn-s-1-inner">Batal</div>
                                    </button>
                                    <button type="submit" class="btn btn-primary btn-s-1" :disabled="waiting">
                                        <div class="btn-s-1-inner">{{ waiting ? 'Harap tunggu ...' : 'Simpan Data' }}</div>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";

export default {
    name: 'PassingGradeLimitForm',
    data() {
        return {
            label           : 'Tambah',
            form : {
                id             : "",
                min_pg_utbk    : "",
                max_pg_utbk    : "",
                min_pg_rapor   : "",
                max_pg_rapor   : ""
            },
            submitted       : false,
            waiting         : false
        }
    },
    validations: {
        form: {
            min_pg_utbk: {
                required
            },
            max_pg_utbk: {
                required
            },
            min_pg_rapor: {
                required
            },
            max_pg_rapor: {
                required
            }
        }
    },
    methods: {
        loadForm: function() {
            this.getData();
            document.getElementById('btn-modal-passing-grade-limit').click();
        },
        reloadData: function() {
            document.getElementById('btn-close-modal-passing-grade-limit').click();
            this.$parent.$children[0].$children[0].getData();

            for (let key in this.form) {
                this.form[key] = '';
            }
        },
        onSubmit: function () {
            this.waiting    = true;
            this.submitted  = true;

            // stop here if form is invalid
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Harap lengkapi form',
                });

                this.waiting = false;
                return;
            } else {    
                let formData = new FormData();
                for (let key in this.form) {
                    formData.append(key, this.form[key]);
                }

                this.$http.post(process.env.VUE_APP_APIHOST + 'passing-grade-limit/save', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                        if (response.data.status) {
                            this.$swal({
                                icon: 'success',
                                title: 'Success',
                                text: response.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.reloadData();
                                }
                            });
                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: response.data.message,
                            });
                        }
                        this.waiting = false;
                    })
                .catch(function () {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Please check your internet connection.',
                    });
                    this.waiting = false;
                    return;
                });

            }
        },
        getData: function() {
            let uri         = process.env.VUE_APP_APIHOST+'passing-grade-limit/check';
            this.$http.get(uri).then(res => {
                if(res.data.status) {
                    let datasets = res.data.data;

                    for (let key in datasets) {
                        if (Object.prototype.hasOwnProperty.call(datasets, key)) {
                            this.form[key] = datasets[key];
                        }
                    }
                }
            });
        }
    },
}
</script>
